import PrefixEnum from '../prefixes'

export default Object.freeze({
    '360shape.gymondo.fitness': PrefixEnum.SHAPE_360,
})
